$(document).ready(function() {
  $(document).on('focus', ".date-mask", function(){
    $(this).inputmask({
      alias: "datetime",
      inputFormat: "yyyy/mm/dd",
      placeholder: "YYYY-MM-DD"
    });
  })
});
